import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class AuthService {

  accountsToken = '';
  hardwareToken = '';
  leadsToken = '';

  token$ = new Subject<null>();

  constructor() {
    try {
      const token = localStorage.getItem('jwt');
      const [, claims, ] = token.split('.');
      const claimsj = JSON.parse(atob(claims));
      console.log('got claims from localstorage', claimsj);
      const exp = new Date(claimsj.exp * 1000);
      console.log('exp', exp);
      if (claimsj.exp > (new Date().getTime() / 1000)) {
        this.setTokens(token, token);
      }
    } catch (err) {
      console.error('could not get jwt from localstorage', err);
    }
  }

  getAccountsToken(): string {
    // if (!this.accountsToken) {
    //   throw new Error('missing token');
    // }
    return this.accountsToken;
  }
  getHardwareToken(): string {
    // if (!this.hardwareToken) {
    //   throw new Error('missing token');
    // }
    return this.hardwareToken;
  }

  setTokens(accountsToken: string, hardwareToken: string) {
    this.accountsToken = accountsToken;
    this.hardwareToken = hardwareToken;
    this.token$.next(null);
  }
}



// WEBPACK FOOTER //
// ./src/app/auth.service.ts